import React, { useContext } from 'react';
import * as PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { isUserFromSuperOrganization } from '../../UserUtils';
import { useClaim } from '../ClaimContainer';
import ContactsContextProvider, { ContactsContext } from '../ContactsContext';
import { useCms } from '../hooks/useCms';

import ContactSearchContainer from './ContactSearchContainer';

const ContactSearchContainerOutOfClaim = ({
  textInputRef,
  overrideOfContactsContextSearchOrganizationId,
  reuseExistingContactsContextIfInClaim = false,
  ...restProps
}) => {
  const { user } = useCms();
  const { claim } = useClaim();
  const existingContactsContext = useContext(ContactsContext);
  const isInContactsContext = !isEmpty(existingContactsContext);
  const isInClaimContext = claim !== null;

  if (overrideOfContactsContextSearchOrganizationId && !isUserFromSuperOrganization(user)) {
    throw Error('Permission Denied');
  }

  // If reuseExistingContactsContextIfInClaim is true and we're in a claim with contacts context, just render the child
  if (reuseExistingContactsContextIfInClaim && isInClaimContext && isInContactsContext) {
    return <ContactSearchContainer textInputRef={textInputRef} {...restProps} />;
  }

  // Otherwise, wrap with our own provider
  return (
    <>
      <ContactsContextProvider
        contactsOrganizationId={overrideOfContactsContextSearchOrganizationId || user.organization_id}
        contacts={[]}
        onAddContact={() => {}}
      >
        <ContactSearchContainer textInputRef={textInputRef} RemoveOutOfClaimDivider {...restProps} />
      </ContactsContextProvider>
    </>
  );
};

ContactSearchContainerOutOfClaim.propTypes = {
  textInputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  overrideOfContactsContextSearchOrganizationId: PropTypes.number,
  reuseExistingContactsContextIfInClaim: PropTypes.bool,
};

export default ContactSearchContainerOutOfClaim;
